import React from 'react';
import Layout from '../../components/Shared/Layout';
import BeatBugs from '../../components/Portfolio/beatbugs';
import '../../assets/css/beatbugs.css';
import * as ReactGA from 'react-ga';

const $ = typeof window !== `undefined` ? require('jquery') : null;

class BeatPage extends React.Component {
  /* constructor(props) {
      super(props);
  } */
  componentDidMount() {
    ReactGA.set({
      title: 'Portfolio/Beatbugs',
    });
    ReactGA.pageview(this.props.location.pathname);
  }

  render() {
    return (
      <Layout>
        <BeatBugs />
      </Layout>
    );
  }
}

export default BeatPage;
